export const currentTheme = (state) => state.themes.theme
export const isDarkTheme = (state) => state.themes.theme === 'dark'
